import React from 'react';
import { Helmet } from 'react-helmet-async';
import { faqs, testimonials } from '../mock';

const BASE = 'https://lowcountry-test.preview.emergentagent.com';

const localBusiness = {
  '@context': 'https://schema.org',
  '@type': 'Plumber',
  '@id': `${BASE}/#business`,
  name: 'Victory Plumbing',
  image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_lowcountry-test/artifacts/hj7l1f73_unnamed.png',
  url: BASE,
  telephone: '+19124299428',
  email: 'info@victoryplumbingsav.com',
  priceRange: '$$',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '2109 Colorado Ave Unit D',
    addressLocality: 'Savannah',
    addressRegion: 'GA',
    postalCode: '31404',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: 32.0389, longitude: -81.0919 },
  areaServed: ['Savannah', 'Pooler', 'Richmond Hill', 'Tybee Island', 'Garden City', 'Port Wentworth', 'Thunderbolt', 'Bloomingdale', 'Hinesville', 'Rincon'],
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '08:00', closes: '17:00',
  }],
  founder: { '@type': 'Person', name: 'Kyle Hagemes' },
  foundingDate: '2021',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: String(testimonials.length),
    bestRating: '5',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

const buildFaqSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

const buildServiceSchema = (svc) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: svc.name,
  serviceType: svc.serviceType,
  description: svc.description,
  url: `${BASE}${svc.path}`,
  provider: { '@type': 'Plumber', '@id': `${BASE}/#business`, name: 'Victory Plumbing' },
  areaServed: localBusiness.areaServed.map((a) => ({ '@type': 'City', name: a })),
});

const buildBreadcrumbSchema = (crumbs) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: crumbs.map((c, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: c.name,
    item: `${BASE}${c.path}`,
  })),
});

export default function StructuredData({ faq = false, faqItems = null, service = null, breadcrumbs = null, business = true }) {
  return (
    <Helmet>
      {business && <script type="application/ld+json">{JSON.stringify(localBusiness)}</script>}
      {faq && <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>}
      {faqItems && faqItems.length > 0 && (
        <script type="application/ld+json">{JSON.stringify(buildFaqSchema(faqItems))}</script>
      )}
      {service && (
        <script type="application/ld+json">{JSON.stringify(buildServiceSchema(service))}</script>
      )}
      {breadcrumbs && breadcrumbs.length > 0 && (
        <script type="application/ld+json">{JSON.stringify(buildBreadcrumbSchema(breadcrumbs))}</script>
      )}
    </Helmet>
  );
}
